import { PencilSimple, Trash } from '@phosphor-icons/react';
import { Button } from '../../../Utility/Button';
import usePromptFunctions from '../../../../Hooks/usePromptFunctions';
import AdminViewHeader from '../../../Utility/AdminViewHeader';
import { PromptFunction } from '../../../../Types';
import AdminViewContent from '../../../Utility/AdminViewContent';
import useGlobals from '../../../../Hooks/useGlobals';
import { PaginationWrapper } from '../../../Utility/PaginationWrapper';
import { PaginationListType } from '../../../../Types/PaginationParams';
import { connectorService } from '../../../../Services/connectorService';
import useSearchFilter from '../../../../Hooks/useSearchFilter';
import SearchFilter from '../../../Utility/SearchFilter';

function PromptFunctionsTab() {
    const { settings, userSettings } = useGlobals();
    const { PromptFunctionsActions, handleNavigate, i18n, windowWidth, getBreakpoint } = usePromptFunctions();
    const GRID_COLS = 'grid-cols-[minmax(157px,300px),minmax(157px,1fr)]';

    const { query, localQuery, searchActions } = useSearchFilter({
        initialQuery: null,
    });

    return (
        <>
            <SearchFilter
                value={localQuery}
                onChange={searchActions.setLocalQuery}
                onApply={searchActions.applyQuery}
                onClear={searchActions.clearQuery}
            />
            <div className="mb-4 md:hidden w-full">
                {(!settings.demo || userSettings.isSuperAdmin) && (
                    <Button className="w-full mb-2" onClick={() => handleNavigate('new')}>
                        {i18n.translate({
                            id: 'button.newFunction',
                            sourceName: 'PromptFunctions',
                        })}
                    </Button>
                )}
            </div>
            <div className="hidden md:block">
                <AdminViewHeader
                    gridCols={GRID_COLS}
                    cols={{
                        cols: [
                            {
                                text: i18n.translate({
                                    id: 'adminHeader.mainCol',
                                    sourceName: 'Main',
                                }),
                            },
                        ],
                        button:
                            !settings.demo || userSettings.isSuperAdmin
                                ? {
                                      text: i18n.translate({
                                          id: 'button.newFunction',
                                          sourceName: 'PromptFunctions',
                                      }),
                                      function: () => handleNavigate('new'),
                                  }
                                : undefined,
                    }}
                />
                <hr className="border-layout-borderColor mt-5" />
            </div>
            <PaginationWrapper
                listType={PaginationListType.Connectors}
                itemsFunction={connectorService.getPromptFunctionsByPage}
                itemsPerPage={15}
                query={query ?? null}
                renderItem={(promptFunction: PromptFunction, index: number) => (
                    <AdminViewContent
                        key={promptFunction.identifier}
                        mobile={windowWidth < getBreakpoint('md')}
                        identifier={promptFunction.identifier}
                        gridCols={GRID_COLS}
                        cols={{
                            optionalCols: [
                                {
                                    content: promptFunction.title ?? '',
                                    image: promptFunction.image,
                                    showImage: true,
                                },
                            ],
                            button: {
                                buttons: [
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'primaryRound'
                                                : 'disabledRound',
                                        onClick: () =>
                                            (!settings.demo || userSettings.isSuperAdmin) &&
                                            handleNavigate(promptFunction.identifier),
                                        icon: <PencilSimple />,
                                    },
                                    {
                                        variant:
                                            !settings.demo || userSettings.isSuperAdmin
                                                ? 'secondaryRound'
                                                : 'disabledRound',
                                        onClick: () =>
                                            (!settings.demo || userSettings.isSuperAdmin) &&
                                            PromptFunctionsActions.handleOpenConfirmDialog(promptFunction.identifier),
                                        icon: <Trash />,
                                    },
                                ],
                            },
                        }}
                    />
                )}
            />
        </>
    );
}

export default PromptFunctionsTab;
